module.exports = __webpack_public_path__ + "img/check_in_circle.39d9777a.svg";